import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M15.22 7.003a.75.75 0 0 1 .969-.432l5.941 2.28a.75.75 0 0 1 .432.97l-2.281 5.94a.75.75 0 0 1-1.4-.537l1.632-4.252-1.086.484a11.2 11.2 0 0 0-5.451 5.174.75.75 0 0 1-1.198.19L9 13.046l-6.22 6.22a.75.75 0 0 1-1.061-1.061l6.75-6.75.114-.094a.75.75 0 0 1 .946.094l3.606 3.607a12.7 12.7 0 0 1 5.679-4.974l1.086-.484-4.251-1.631a.75.75 0 0 1-.431-.969z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const ArrowTrendingUpIcon = ForwardRef;